import React, { useState, useRef, useEffect } from 'react';

function MultiSelect({
    label,
    options,
    selected,
    onChange,
    placeholder,
    disabled = false,
    showSelectAll = false,
    wide = false
}) {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    // Close dropdown when clicking outside
    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleToggle = (option) => {
        if (selected.includes(option)) {
            onChange(selected.filter(s => s !== option));
        } else {
            onChange([...selected, option]);
        }
    };

    const handleSelectAll = () => {
        if (selected.length === options.length) {
            onChange([]);
        } else {
            onChange([...options]);
        }
    };

    const displayText = selected.length === 0
        ? placeholder
        : `${selected.length} selected`;

    return (
        <div className="control-group">
            {label && <label>{label}</label>}
            <div className={`custom-multiselect${wide ? ' wide' : ''}`} ref={dropdownRef}>
                <div
                    className="multiselect-button"
                    onClick={() => !disabled && setIsOpen(!isOpen)}
                    style={{ opacity: disabled ? 0.6 : 1, cursor: disabled ? 'not-allowed' : 'pointer' }}
                >
                    <span>{displayText}</span>
                    <span>{isOpen ? '▲' : '▼'}</span>
                </div>

                {isOpen && !disabled && (
                    <div className="multiselect-dropdown">
                        {options.length === 0 && (
                            <div style={{ padding: '12px', color: '#999', fontSize: '13px' }}>
                                No options available
                            </div>
                        )}

                        {options.length > 0 && showSelectAll && (
                            <div
                                className="multiselect-item select-all"
                                onClick={handleSelectAll}
                            >
                                <input
                                    type="checkbox"
                                    checked={selected.length === options.length && options.length > 0}
                                    readOnly
                                />
                                <span>{selected.length === options.length ? 'Deselect All' : 'Select All'}</span>
                            </div>
                        )}

                        {options.map(option => (
                            <div
                                key={option}
                                className="multiselect-item"
                                onClick={() => handleToggle(option)}
                            >
                                <input
                                    type="checkbox"
                                    checked={selected.includes(option)}
                                    readOnly
                                />
                                <span>{option}</span>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

export default MultiSelect;
